import http from "../../core/services/http.service";

const BacsService = {
  getBacsBatches(params = null) {
    return http.get('/api/v1/settlements/bacs-list/', {params})
  },
  getSettlementBacsCsvData(uuid) {
    return http.get(`api/v1/settlements/bacs-csv-data/${uuid}/`);
  },
};

export default BacsService;